import { useEffect, useState } from 'react';
import Participants from '../ui/Participants';
import { useParticipants } from '../discord/useParticipants';

/**
 * Avant que le direct commence.
 *
 * Une différence de fond avec la salle d'attente d'une projection, et elle
 * change ce qu'on peut écrire à l'écran : une projection **démarrera** à
 * l'heure dite, parce que c'est l'horloge qui la commande. Un direct, non.
 * L'heure annoncée est un rendez-vous, pas un déclencheur — c'est OBS qui
 * décide, et il peut être en retard.
 *
 * On annonce donc « prévu à » et non « démarre dans », et une fois l'heure
 * passée on cesse de compter à rebours pour dire simplement qu'on attend. Un
 * compte à rebours figé à zéro laisserait croire à une panne.
 */

function compteARebours(secondes) {
  const total = Math.max(0, Math.round(secondes));
  const heures = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const reste = total % 60;

  if (heures >= 1) return `${heures} h ${String(minutes).padStart(2, '0')}`;
  if (minutes >= 1) return `${minutes} min ${String(reste).padStart(2, '0')} s`;
  return `${reste} seconde${reste > 1 ? 's' : ''}`;
}

export default function AttenteDirect({ direct }) {
  const participants = useParticipants();

  // L'écart entre l'horloge du serveur et la nôtre, mesuré une fois : sans
  // lui, une machine en avance de deux minutes afficherait un rendez-vous
  // déjà passé alors qu'il ne l'est pas.
  const [restant, setRestant] = useState(() => direct.starts_in ?? 0);

  useEffect(() => {
    const depart = Date.now();
    const initial = direct.starts_in ?? 0;

    const battement = setInterval(() => {
      setRestant(Math.max(0, initial - (Date.now() - depart) / 1000));
    }, 1000);

    return () => clearInterval(battement);
  }, [direct.starts_in]);

  const heure = direct.scheduled_at
    ? new Date(direct.scheduled_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    : null;

  const passee = restant <= 0;

  return (
    <div className="centre">
      <p className="discret">📡 Direct</p>

      <h1 className="titre">{direct.title}</h1>

      {passee ? (
        <>
          <p className="compte-a-rebours">Bientôt</p>
          <p className="discret">
            L'heure est passée, la diffusion n'a pas encore commencé.
            <br />
            L'écran basculera tout seul dès qu'elle démarre.
          </p>
        </>
      ) : (
        <>
          <p className="compte-a-rebours">{compteARebours(restant)}</p>
          <p className="discret">
            {heure ? `Prévu à ${heure}.` : 'Prévu bientôt.'}
            <br />
            Reste ici : l'écran basculera tout seul.
          </p>
        </>
      )}

      <Participants participants={participants} />
    </div>
  );
}
